module.exports = __webpack_public_path__ + "static/media/val.05aff04e.jpg";